import { database } from "../firebase";

const subscribeToCourses = (onReceive, onDelete) => {
  const ref = database.ref(`courses`);

  const handler = (snapshot) =>
    onReceive({
      id: snapshot.key,
      ...snapshot.val(),
    });

  const handlerOnDelete = (snapshot) => onDelete(snapshot.key);

  ref.on("child_added", handler);
  ref.on("child_changed", handler);
  ref.on("child_removed", handlerOnDelete);

  return () => {
    ref.off("child_added", handler);
    ref.off("child_changed", handler);
    ref.off("child_removed", handlerOnDelete);
  };
};

const subscribeToEpisodes = (onReceive, onDelete) => {
  const ref = database.ref(`episodes`);

  const handler = (snapshot) =>
    onReceive({
      id: snapshot.key,
      ...snapshot.val(),
    });

  const handlerOnDelete = (snapshot) => onDelete(snapshot.key);

  ref.on("child_added", handler);
  ref.on("child_changed", handler);
  ref.on("child_removed", handlerOnDelete);

  return () => {
    ref.off("child_added", handler);
    ref.off("child_changed", handler);
    ref.off("child_removed", handlerOnDelete);
  };
};

const subscribeToFreeEpisodes = (onReceive, onDelete) => {
  const ref = database.ref(`free/episodes`);

  const handler = (snapshot) =>
    snapshot.val() === true ? onReceive(snapshot.key) : onDelete(snapshot.key);

  const handlerOnDelete = (snapshot) => onDelete(snapshot.key);

  ref.on("child_added", handler);
  ref.on("child_changed", handler);
  ref.on("child_removed", handlerOnDelete);

  return () => {
    ref.off("child_added", handler);
    ref.off("child_changed", handler);
    ref.off("child_removed", handlerOnDelete);
  };
};

const subscribeToFree = (onReceive) => {
  const ref = database.ref(`free`);

  const handler = (snapshot) => {
    if (snapshot.exists())
      onReceive(snapshot.val());
    else onReceive({});
  }

  ref.on("value", handler);

  return () => {
    ref.off("value", handler);
  };
};

const subscribeToCompleted = (userId, onReceive) => {
  const ref = database.ref(`completed/${userId}`);

  const handler = (snapshot) => {
    if (snapshot.exists())
      onReceive(snapshot.val());
    else onReceive({});
  }

  ref.on("value", handler);

  return () => {
    ref.off("value", handler);
  };
};

const subscribeToPurchases = (userId, onReceive) => {
  const ref = database.ref(`purchases/${userId}`);

  const handler = (snapshot) => {
    if (snapshot.exists())
      onReceive(snapshot.val());
    else onReceive({});
  }

  ref.on("value", handler);

  return () => {
    ref.off("value", handler);
  };
};

const subscribeToChapters = (episodeId, onReceive, onDelete) => {
  const ref = database.ref(`chapters/${episodeId}`);

  const handler = (snapshot) =>
    onReceive({
      id: snapshot.key,
      ...snapshot.val(),
    });

  const handlerOnDelete = (snapshot) => onDelete(snapshot.key);

  ref.on("child_added", handler);
  ref.on("child_changed", handler);
  ref.on("child_removed", handlerOnDelete);

  return () => {
    ref.off("child_added", handler);
    ref.off("child_changed", handler);
    ref.off("child_removed", handlerOnDelete);
  };
};

const subscribeToFreeChapters = (episodeId, onReceive, onDelete) => {
  const ref = database.ref(`free/chapters/${episodeId}`);

  const handler = (snapshot) =>
    snapshot.val() === true ? onReceive(snapshot.key) : onDelete(snapshot.key);

  const handlerOnDelete = (snapshot) => onDelete(snapshot.key);

  ref.on("child_added", handler);
  ref.on("child_changed", handler);
  ref.on("child_removed", handlerOnDelete);

  return () => {
    ref.off("child_added", handler);
    ref.off("child_changed", handler);
    ref.off("child_removed", handlerOnDelete);
  };
};

const subscribeToFreeLessons = (chapterId, onReceive, onDelete) => {
  const ref = database.ref(`free/lessons/${chapterId}`);

  const handler = (snapshot) =>
    snapshot.val() === true ? onReceive(snapshot.key) : onDelete(snapshot.key);

  const handlerOnDelete = (snapshot) => onDelete(snapshot.key);

  ref.on("child_added", handler);
  ref.on("child_changed", handler);
  ref.on("child_removed", handlerOnDelete);

  return () => {
    ref.off("child_added", handler);
    ref.off("child_changed", handler);
    ref.off("child_removed", handlerOnDelete);
  };
};

const subscribeToLessons = (chapterId, onReceive, onDelete) => {
  const ref = database.ref(`lessons/${chapterId}`);

  const handler = (snapshot) =>
    onReceive({
      id: snapshot.key,
      ...snapshot.val(),
    });

  const handlerOnDelete = (snapshot) => onDelete(snapshot.key);

  ref.on("child_added", handler);
  ref.on("child_changed", handler);
  ref.on("child_removed", handlerOnDelete);

  return () => {
    ref.off("child_added", handler);
    ref.off("child_changed", handler);
    ref.off("child_removed", handlerOnDelete);
  };
};

const subscribeToLessonDetails = (lessonId, onReceive, onDelete) => {
  const ref = database.ref(`lessons_details/${lessonId}`);

  const handler = (snapshot) => onReceive(snapshot.key, snapshot.val());

  const handlerOnDelete = (snapshot) => onDelete(snapshot.key);

  ref.on("child_added", handler);
  ref.on("child_changed", handler);
  ref.on("child_removed", handlerOnDelete);

  return () => {
    ref.off("child_added", handler);
    ref.off("child_changed", handler);
    ref.off("child_removed", handlerOnDelete);
  };
};

const subscribeToCourse = (courseId, onReceive, onDelete) => {
  const ref = database.ref(`courses/${courseId}`);

  const handler = (snapshot) =>
    onReceive({
      id: snapshot.key,
      value: snapshot.val(),
    });

  const handlerOnDelete = (snapshot) => onDelete(snapshot.key);

  ref.on("child_added", handler);
  ref.on("child_changed", handler);
  ref.on("child_removed", handlerOnDelete);

  return () => {
    ref.off("child_added", handler);
    ref.off("child_changed", handler);
    ref.off("child_removed", handlerOnDelete);
  };
};

const updateCheckout = ({
  courseId,
  videoPromotion,
  priceTotal,
  isPromotion,
}) =>
  new Promise((resolve, reject) => {
    let updates = {};

    updates[`courses/${courseId}/videoPromotion`] = videoPromotion;
    updates[`courses/${courseId}/priceTotal`] = parseFloat(priceTotal);
    updates[`courses/${courseId}/isPromotion`] = isPromotion;

    database.ref().update(updates, (error) => {
      if (error) reject("Ocurrió un error.");
      else resolve();
    });
  });

export default {
  subscribeToCourse,
  subscribeToCourses,
  subscribeToEpisodes,
  subscribeToChapters,
  subscribeToLessons,
  subscribeToFreeEpisodes,
  subscribeToFreeChapters,
  subscribeToFreeLessons,
  subscribeToLessonDetails,
  updateCheckout,
  subscribeToFree,
  subscribeToCompleted,
  subscribeToPurchases
};
